module.exports = __webpack_public_path__ + "img/fig16.bc7ba403.jpg";